import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Iframe from 'components/Iframe/Iframe';
import { getDiscoverIframeUrl } from '../../constants';
import Media from 'react-media';
import styles from 'theme';
import { Route, Switch } from 'react-router-dom';
import ResultView from './ResultView';
import { ROUTE_DISCOVER_QUESTIONNAIRE, ROUTE_DISCOVER_RESULT } from '../../RouteList';
import Intro from './Intro';

@inject('authStore')
@observer
export default class Discover extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { authStore: { user, isImpersonator } } = this.props;
    const currentUser = isImpersonator || user;
    console.log('email', currentUser);
    return (
      <Switch>
        <Route exact path="/discover">
          <Intro />
        </Route>
        <Route exact path={ROUTE_DISCOVER_QUESTIONNAIRE}>
          <Media query={{ maxWidth: styles.mq.large }}>
            {matches =>
              currentUser.email && (
                <Iframe
                  src={getDiscoverIframeUrl(currentUser)}
                  height={matches ? 'calc(100vh - 145px)' : '100%'}
                />
              )
            }
          </Media>
        </Route>
        <Route exact path={ROUTE_DISCOVER_RESULT} component={ResultView} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/discover/Discover.js